export const faqCategories = [
    {
        id: 'general',
        name: 'General',
        description: 'General questions about watchfaces',
        icon: '❓',
        color: '#3B82F6'
    },
    {
        id: 'installation',
        name: 'Installation & Setup',
        description: 'Installation and setup questions',
        icon: '📱',
        color: '#10B981'
    },
    {
        id: 'settings',
        name: 'Settings & Configuration',
        description: 'Settings and configuration help',
        icon: '⚙️',
        color: '#F59E0B'
    },
    {
        id: 'weather',
        name: 'Weather & Data',
        description: 'Weather data and external services',
        icon: '🌤️',
        color: '#06B6D4'
    },
    {
        id: 'tides',
        name: 'Tides',
        description: 'Tide data and Stormglass.io setup',
        icon: '🌊',
        color: '#8B5CF6'
    },
    {
        id: 'gps',
        name: 'GPS & Location',
        description: 'GPS fixes and location services',
        icon: '📍',
        color: '#EF4444'
    },
    {
        id: 'permissions',
        name: 'Permissions',
        description: 'Watchface permissions and privacy',
        icon: '🔒',
        color: '#6B7280'
    },
    {
        id: 'purchase',
        name: 'Purchase & Keys',
        description: 'Pro features, keys, and payment',
        icon: '💳',
        color: '#059669'
    },
    {
        id: 'troubleshooting',
        name: 'Troubleshooting',
        description: 'Common problems and solutions',
        icon: '🔧',
        color: '#DC2626'
    },
    {
        id: 'colors',
        name: 'Colors & Themes',
        description: 'Color options and theme settings',
        icon: '🎨',
        color: '#EC4899'
    },
    {
        id: 'fonts',
        name: 'Fonts',
        description: 'Available fonts and typography options',
        icon: '🔤',
        color: '#6366F1'
    }
];
export const faqData = [
    // General Questions
    {
        id: 'gps-fix',
        category: 'gps',
        keywords: ['gps', 'fix', 'signal', 'location', 'position', 'gps?', 'gps fix', 'gps signal'],
        question: 'What is a GPS fix and how can I do it? / Why do some options show "GPS?"',
        answer: 'A GPS fix is needed to let the watchface know where you are to calculate everything regarding suntimes and moontimes correctly. A GPS fix can be done by starting an activity and wait until the watch got the GPS signal or by long pressing the GPS button and wait until the watch got the GPS signal. After that you can return to the watchface and everything should show up correctly.',
        priority: 5,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'userdata-collection',
        category: 'permissions',
        keywords: ['data', 'collection', 'privacy', 'userdata', 'personal', 'information', 'collect'],
        question: 'Do the watchfaces collect any userdata?',
        answer: 'All TitanicTurtle watchfaces do not collect any userdata and do not send it elsewhere. They only display data provided by Garmin or do some calculations based on it (like active calories). In general, all data provided by Garmin to 3rd party watchfaces is not personalized - there is no name or similar to be read out for example.',
        priority: 4,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'permissions-needed',
        category: 'permissions',
        keywords: ['permissions', 'access', 'background', 'internet', 'gps', 'heart rate', 'bluetooth', 'connect'],
        question: 'Why do the watchfaces need so much permissions?',
        answer: 'TitanicTurtle Watchfaces need permissions to provide the large selection of data / functions. Run in the background when it is not active - this is needed to update tide / weather data from third party providers in combination with the internet permission. Send/receive information to/from the Internet - this is needed to update tide / weather data in combination with running in the background. Read and display data from other apps - Other apps must explicitly provide data to be read by Watchfaces. GPS location - this is needed to calculate times like sunrise/sunset, moonrise/moonset and get the correct weather location. Heart rate, barometer, temperature, and altitude history - data that will be displayed on the watchface - for display purposes only. Your Garmin Connect™ fitness profile - This is needed to display weight, calculate active calories and activate energy saving options to the set sleep times.',
        priority: 4,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'pro-features',
        category: 'purchase',
        keywords: ['pro', 'features', 'crown', 'key', 'trial', 'unlock', 'premium', 'crown symbol', 'key?'],
        question: 'What does ♛ mean and why do some views show "key"?',
        answer: '♛ marks the pro features of this watchface. To unlock them after your 5 days trial you can buy an unlock key. "key?" means that your trial period is over.',
        priority: 5,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'temperature-units',
        category: 'settings',
        keywords: ['temperature', 'units', 'celsius', 'fahrenheit', 'format', 'units', 'change'],
        question: 'How do I change the temperature units?',
        answer: 'Change it by entering your watches system settings (long press the menu button): Navigate to System -> Format -> Units and change it there',
        priority: 3,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'time-format',
        category: 'settings',
        keywords: ['time', 'format', '12h', '24h', 'military', 'timeformat', 'clock', 'display'],
        question: 'How do I set the 12h/24h Format?',
        answer: 'Change it by entering your watches system settings (long press the menu button): Navigate to System -> Format -> Timeformat and change it there',
        priority: 3,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'distance-units',
        category: 'settings',
        keywords: ['distance', 'height', 'units', 'metric', 'imperial', 'miles', 'kilometers', 'feet', 'meters'],
        question: 'How do I change the units for distances or heights?',
        answer: 'Change it by entering your watches system settings (long press the menu button): Navigate to System -> Format -> Units and change it there',
        priority: 3,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'watchface-switch',
        category: 'installation',
        keywords: ['switch', 'watchface', 'change', 'display', 'menu', 'system', 'install'],
        question: 'How do I switch between watchfaces?',
        answer: 'Press and hold the menu button on your watch to enter the system menu. Navigate to "Display Designs" or "Watch Faces" - you will see a list of all installed watchfaces. Use the up/down buttons (or touchscreen if available) to navigate between watchfaces. Press the top-right button to confirm your selection.',
        priority: 4,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'settings-access',
        category: 'settings',
        keywords: ['settings', 'configure', 'options', 'connectiq', 'app', 'phone', 'bluetooth'],
        question: 'How do I access watchface settings?',
        answer: 'Make sure your watch is connected to your phone via Bluetooth. Open the ConnectIQ app on your phone and go to the watchface page. There should be a settings button that opens the configuration options.',
        priority: 4,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'gesture-control',
        category: 'settings',
        keywords: ['gesture', 'wrist', 'movement', 'switch', 'view', 'second gesture', 'hand movement'],
        question: 'How does the second gesture / wrist movement work?',
        answer: 'You can switch views on your device by making a specific gesture with your watch. When you turn your wrist to look at the watch, the display normally comes to life - seconds are displayed or the screen brightens if it\'s dark. If you make this gesture again within 7 seconds, the view on the watchface changes. Make sure not to make the gesture too jerky.',
        priority: 3,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'seconds-display',
        category: 'settings',
        keywords: ['seconds', 'display', 'disappear', 'random', 'battery', 'power', 'save'],
        question: 'Why do the seconds disappear after a short time?',
        answer: 'This is normal for Garmin watches - the watchfaces go into a kind of sleep mode after about 10 seconds to save energy. Then the screen is only updated every minute. When you make a wrist movement to look at the watch, it goes into high power mode for about 10 seconds and updates everything every second. You can display seconds permanently - there is an option in the watchface settings where you specify seconds as a data field. However, this consumes significantly more energy.',
        priority: 3,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'beer-symbol',
        category: 'general',
        keywords: ['beer', 'symbol', 'icon', 'earned', 'activity', 'sports', 'reward'],
        question: 'What does the beer symbol mean?',
        answer: 'This option shows how many beers you have earned today based on sporting activities or strenuous moments.',
        priority: 2,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'subscription-model',
        category: 'purchase',
        keywords: ['subscription', 'permanent', 'one-time', 'payment', 'key', 'valid', 'device'],
        question: 'Is this a subscription or permanent unlock?',
        answer: 'When purchasing a key, the key is bound to your device. This means: As long as you use the same device, the key is permanently valid. As soon as you switch to another device, a new key is required.',
        priority: 4,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'installation-fails',
        category: 'troubleshooting',
        keywords: ['installation', 'fails', 'queue', 'installing', 'garmin', 'server', 'problem'],
        question: 'Installation always fails / stuck in queue',
        answer: 'Garmin sometimes has problems with the installation process, there is nothing a 3rd party developer can do about it unfortunately.\n\nYou can try the following:\n- Reboot the watch and restart the ConnectIQ app on your phone.\n- Make sure the phone screen does not turn off and the ConnectIQ app stays open while installing or updating.\n- Try the installation again after a short time.\n\nIf it keeps failing, it is usually a temporary issue on Garmin/ConnectIQ side that resolves itself later.',
        priority: 4,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'settings-load-slow',
        category: 'troubleshooting',
        keywords: ['settings', 'load', 'slow', 'server', 'garmin', 'problem', 'timeout'],
        question: 'Settings cannot be opened or load slowly',
        answer: 'It seems like Garmin has problems with its servers at the moment - that is where the settings are stored. Unfortunately, there is nothing a 3rd party developer can do about it. Usually this is fixed within 1-2 hours. You could try to reboot the watch and restart the ConnectIQ app again or try at a later date.',
        priority: 3,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'vx-vs-elite',
        category: 'purchase',
        keywords: ['vx', 'elite', 'difference', 'version', 'garmin pay', 'website', 'kauf', 'unterschied'],
        question: 'What is the difference between VX and Elite versions?',
        answer: 'Technically both versions are identical and offer the same features. The only difference is how they are purchased and activated.\n\nElite Version:\n- Separate installation purchased directly via Garmin Pay in the ConnectIQ Store.\n- Bound to your Garmin account: if you buy a new watch, you can install the Elite version again without a separate key.\n- Garmin Pay is not available on all watches or in all countries.\n- Important: When purchasing an Elite version via Garmin Pay, no unlock code is sent – the Elite version is unlocked directly after purchase.\n\nVX / Website Version:\n- Compatible with a larger number of devices.\n- Includes a built-in free trial period.\n- After the trial, you can purchase an unlock code on this website to permanently unlock the VX version (or its pro features).\n- The unlock code is always bound to the device / WatchfaceID for which it was purchased.',
        priority: 5,
        lastUpdated: '2026-02-27'
    },
    {
        id: 'watchface-not-showing',
        category: 'installation',
        keywords: ['watchface', 'not showing', 'not visible', 'display', 'choose', 'select', 'anzeigen', 'nicht sichtbar'],
        question: 'The watchface is installed but does not show on my watch',
        answer: 'If the watchface is installed but not shown on the watch, it may not be selected as the active watchface yet.\n\nOn most devices you can change the watchface as follows:\n1. Press and hold the menu button on your watch (or the corresponding button on touchscreen devices) to open the system menu.\n2. Navigate to \"Watch Faces\" or \"Display Designs\".\n3. You will see a list of all installed watchfaces. Use the up/down buttons or the touchscreen to navigate.\n4. Confirm the selected watchface with the top-right button. The watchface should now be visible on your watch.',
        priority: 4,
        lastUpdated: '2026-02-27'
    },
    {
        id: 'switchview-problem',
        category: 'troubleshooting',
        keywords: ['switchview', 'display', 'changes', 'constantly', 'different', 'data', 'menu'],
        question: 'Display constantly changes to different data',
        answer: 'You may see the switching view feature (Switchview). If you do not want to use this feature, set the switch view 2 (top/bottom depending on the watch face) to \'Do Not Switch\'. Or set this value to the same as Switchview 1.',
        priority: 3,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'activity-distance',
        category: 'troubleshooting',
        keywords: ['activity', 'distance', 'cycling', 'running', 'swimming', 'week', 'month', 'incorrect'],
        question: 'Activity distances are not correct for weekly/monthly display',
        answer: 'Are the activities recorded on the same device? Activities can only be evaluated if they are recorded directly on the watch. This is unfortunately a Garmin limitation for 3rd party apps. Garmin provides the weekly distance in an extra field, so it is often possible that this is correct, but cannot be totaled for the other time periods.',
        priority: 3,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'location-update',
        category: 'gps',
        keywords: ['location', 'position', 'update', 'wrong', 'weather', 'gps', 'signal'],
        question: 'How to update/change the displayed location?',
        answer: 'The position data of the watchface must be updated. Go to the start screen of an activity on the watch, such as "Running" and wait until the watch has found a GPS signal. The displayed location should then update within the next few minutes (the watch must be connected to the phone via GPS, where the Connect app (not ConnectIQ) runs at least in the background). A second option is to activate GPS on the phone. The watch must also be connected via Bluetooth here. This method is somewhat slower, but should work just as well.',
        priority: 4,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'weather-waiting',
        category: 'weather',
        keywords: ['weather', 'waiting', 'data', 'garmin', 'yr', 'provider', 'load'],
        question: 'Why does it show "Waiting for data"?',
        answer: 'Apparently the weather data is not loaded correctly on your watch, sometimes there are problems when \'Garmin Weather\' is selected as the weather data provider in the watchface settings. If \'Yr\' is offered as the weather data provider in the watchface settings, it is recommended to try this option, it usually runs more reliably than the Garmin weather service.',
        priority: 4,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'pro-locked',
        category: 'purchase',
        keywords: ['pro', 'locked', 'key?', 'requires key', 'check app info', 'crown', 'trial'],
        question: 'Why are features locked or showing "key?"?',
        answer: 'Some functions of this watchface require a key after the trial period (5 days). These functions are marked with a small crown in the watchface settings. The feature you want to use seems to be one of those features. In most cases you can always select a different option in the settings or get a key on the website.',
        priority: 5,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'new-device-key',
        category: 'purchase',
        keywords: ['new', 'device', 'watch', 'key', 'code', 'replacement', 'repair', 'warranty'],
        question: 'I got a new device but my old key doesn\'t work',
        answer: 'The old code will no longer work as the WatchfaceID has changed. If you send me the new WatchfaceID (number in the top field of the watchface settings) I can send you a new working key.',
        priority: 4,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'missing-key',
        category: 'purchase',
        keywords: ['missing', 'key', 'code', 'not sent', 'email', 'payment', 'purchase'],
        question: 'I paid but didn\'t receive my key',
        answer: 'The key is sent directly after purchase to the email address you entered.\n\nIf you did not receive it:\n- First, check the spam folder of your email inbox – emails with keys often end up there.\n- In many cases a typo in the email address prevents delivery. If you still cannot find the email, please contact support and provide the email address you used for payment and, if possible, your WatchfaceID.\n\nImportant: When purchasing an Elite version directly via Garmin Pay in the ConnectIQ store, no unlock code is sent. The Elite version is unlocked immediately after purchase and does not require a key.',
        priority: 5,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'timezone-offset',
        category: 'settings',
        keywords: ['timezone', 'offset', 'utc', 'second', 'third', 'time', 'zone', 'minutes'],
        question: 'How do I set timezone offsets?',
        answer: 'Users can select two alternative timezones in most watchfaces, these are named as second timezone and third timezone. In the watchface settings there is a field where users can specify the offset of both timezones in minutes relative to UTC time. The first value in this field stands for the offset of the second timezone, the second value for the offset of the third timezone. Example: -270 120 means the second timezone offset would be -4.5 hours and the third timezone offset +2 hours, always relative to UTC time.',
        priority: 2,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'hour-minute-bar',
        category: 'settings',
        keywords: ['hour', 'minute', 'bar', 'fill', 'color', 'background', 'display'],
        question: 'How does the hour/minute bar work?',
        answer: 'Some watchfaces offer the possibility to fill the hour and minute digits with a color based on various options that users can select in the settings. It is important that the user specifies a fill color that differs from the background color of the digits, otherwise you can\'t see anything.',
        priority: 2,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'double-payment',
        category: 'purchase',
        keywords: ['double', 'payment', 'twice', 'refund', 'money', 'charge'],
        question: 'I was charged twice for the same purchase',
        answer: 'If a user makes a double payment, we will refund the money as soon as possible. However, it may take some time until the money is back in the user\'s account.',
        priority: 3,
        lastUpdated: '2024-01-15'
    },
    {
        id: 'fonts-overview',
        category: 'fonts',
        keywords: ['fonts', 'typography', 'time font', 'data font', 'font preview', 'schriftarten', 'zeitschriften'],
        question: 'Where can I see all available fonts?',
        answer: 'You can view all available time fonts and data fonts on our Fonts page. Visit /fonts to see previews of each font with the current time and example numbers. The page is also accessible from the main navigation menu.',
        priority: 5,
        lastUpdated: '2024-12-12'
    },
    {
        id: 'settings-cant-save',
        category: 'settings',
        keywords: ['settings', 'save', 'error', 'cannot save', 'speichern', 'fehler', 'einstellungen', 'theme string', 'color scheme'],
        question: 'Settings cannot be saved – an error message appears',
        answer: 'Sometimes Garmin servers have trouble processing certain characters. Try clearing the color theme string field (if present) in the watchface settings and save again. This usually resolves the issue.',
        relatedItems: ['settings-wont-open'],
        priority: 4,
        lastUpdated: '2026-02-27'
    },
    {
        id: 'settings-wont-open',
        category: 'settings',
        keywords: ['settings', 'open', 'wont open', 'connectiq', 'install', 'einstellungen', 'öffnen', 'installieren'],
        question: 'The watchface settings won\'t open',
        answer: 'Fully close the ConnectIQ app and restart your watch. If you only see an "Install" button instead of "Settings", the watchface is not yet installed on your watch – see the Installation guide at /guides/purchase.',
        relatedItems: ['settings-cant-save'],
        priority: 4,
        lastUpdated: '2026-02-27'
    },
    {
        id: 'settings-missing-options',
        category: 'settings',
        keywords: ['settings', 'missing', 'option', 'not available', 'cannot find', 'nicht verfügbar', 'fehlt', 'finde nicht'],
        question: 'I cannot find a specific setting option',
        answer: 'Not all options are available on all devices. The available options depend on your watch model and the specific watchface. Newer features may only be available on devices that support the required hardware or software APIs.',
        priority: 3,
        lastUpdated: '2026-02-27'
    },
    {
        id: 'settings-na-value',
        category: 'troubleshooting',
        keywords: ['n/a', 'na', 'not available', 'data', 'field', 'empty', 'missing', 'nicht verfügbar', 'datenfeld', 'leer', 'barometer', 'sensor'],
        question: 'A data field shows only "n/a"',
        answer: 'Your device does not support this data option – usually because it is an older model or lacks the required hardware such as a barometer, pulse oximeter, or specific sensor. Try selecting a different data field for that slot.',
        priority: 3,
        lastUpdated: '2026-02-27'
    }
];
